import Vue from 'vue'

// https://github.com/redxtech/vue-plyr
import VuePlyr from "./components/VuePlyrPlugin/index.js"
Vue.use(VuePlyr);

// https://www.npmjs.com/package/vue-awesome-swiper
// import Swiper from "swiper/dist/js/swiper.min.js";
import swiper_slider from "./components/swiper_slider.vue"
Vue.component('swiper_slider', swiper_slider);

import BlockWrapper from './components/BlockWrapper'
Vue.component('BlockWrapper', BlockWrapper)

// Компоненты страниц Static ============================
/**
 * Страница вакансий
 */
import vacancy from './pages/static/vacancy/Index.vue';
Vue.component('vacancy', vacancy);

/**
 * Лендинг "Сервисы"
 */
// компонент "что мы предлагаем"
import servicesGrid from './pages/static/services/servicesGrid.vue';
Vue.component('servicesGrid', servicesGrid);

/**
 * Консультация экспертов
 */
import interviewpage from './pages/static/interviewpage.vue';
Vue.component('interviewpage', interviewpage);

/**
 * Страница "Проектные продажи" бывш. "Проивзодителям"
 */
//Компонент с тарифами
import tariff from './pages/man0/tariff.vue';
Vue.component('tariff', tariff);
//Компонент с моделями
import createModels from './pages/man0/WeCreateModels.vue';
Vue.component('createmodels', createModels);

//Компонент с реализованными проектами
import DoneProjects from './pages/software/DoneProjects.vue';
Vue.component('doneprojects', DoneProjects);

/**
 * Лендинг "Создание BIM-моделей"
 */
import form_call from './pages/forms/form_call.vue';
Vue.component('formcall', form_call);

/**
 * BuildingSmart
 */
// форма для лендинга бдсм
import form_email from './pages/forms/form_email.vue';
Vue.component('form_email', form_email);

//Универсальный компонент с отправкой сообщений
import form_messages from './pages/forms/sendMessages.vue';
Vue.component('formmessages', form_messages);
//Универсальная форма с заявкой и регистрацией
import send_request from './pages/forms/Send_request.vue';
Vue.component('send_request', send_request);

/**
 * Форма "Заказать услугу"
 */
import start from './pages/static/start/start';
Vue.component('start', start);

/**
 * Страница Лендинга Автодеск
 */
import autodesk from './pages/static/autodesk-bim2.0/autodesk.vue';
Vue.component('landing-autodesk', autodesk);

/**
 * Страница Лендинга Автодеск
 */
import oauthCode from './pages/static/oauth-code/index.vue';
Vue.component('oauth-code', oauthCode);

/**
 * Страница Лендинга Civil
 */
import civil from './pages/static/autodesk-bim2.0/civil.vue';
Vue.component('landing-civil', civil);

/**
 * Страница Лендинга Услуги
 */
import smpp from './pages/static/smpp/index.vue';
Vue.component('landing-smpp', smpp);

/**
 * Страница Лендинга Renga
 */
import renga from './pages/static/autodesk-bim2.0/renga.vue';
Vue.component('landing-renga', renga);

/**
 * Страница лендинга IFC
 */
import ifc from './pages/static/autodesk-bim2.0/ifc.vue'
Vue.component('landing-ifc', ifc)

/**
 * Страница Лендинга ARCHICAD
 */
import archicad from './pages/static/autodesk-bim2.0/archicad.vue';
Vue.component('landing-archicad', archicad);

/**
 * Страница Лендинга Наши кейсы
 */
import cases from './pages/static/cases/index.vue';
Vue.component('landing-cases', cases);

/**
 * Лэндинг ГИСП (GISP)
 */
import gisp from './pages/static/gisp/index.vue'
Vue.component('landing-gisp', gisp)

/**
 * Страница о компании
 */

 import about from './pages/static/about/index.vue'
 Vue.component('landing_about', about)

/**
 * Лэндинг Плагин
 */

import plugin from './pages/static/plugin/index.vue'
Vue.component('landing-plugin', plugin)

/**
 * Лэндинг мастер спецификаций
 */
 
import master_spec from './pages/static/master_spec/index.vue'
Vue.component('landing-master-spec', master_spec)

/**
 * Каталог плагинов
 */
import plugins_catalog from './pages/static/plugins/index.vue'
Vue.component('plugins-catalog', plugins_catalog)

/**
 * Лэндинг Estimate
 */
 
import estimate from './pages/static/estimate/index.vue'
Vue.component('landing-estimate', estimate)

/**
 * Лэндинг тарифов
 */
import promotion from './pages/static/promotion/index.vue'
Vue.component('landing-promotion', promotion)

/**
 * Лэндинг тарифов
 */
import partnerka from './pages/static/partnerka/index.vue'
Vue.component('landing-partnerka', partnerka)
